/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step_Distribute_Point_2Inputs */

const en_landing_step_distribute_point_2 = /** @type {(inputs: Landing_Step_Distribute_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outreach drafted for the desk to review`)
};

/**
* | output |
* | --- |
* | "Outreach drafted for the desk to review" |
*
* @param {Landing_Step_Distribute_Point_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_step_distribute_point_2 = /** @type {((inputs?: Landing_Step_Distribute_Point_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step_Distribute_Point_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_step_distribute_point_2(inputs)
});